import React from "react";

const MatrixTimeToTriggerMenu = props => {
        const {
            setTTTMetric,
            tttMetric
        } = props;
        return (
            <div>
                <div>
                    <input
                        type="radio"
                        id="tttMetricEventTime"
                        name="tttMetric"
                        value="eventTime"
                        defaultChecked
                        onChange={setTTTMetric}
                    />
                    <label>Event Time</label>
                </div>
                <div>
                    <input type="radio"
                           id="tttMetricReceivedAt"
                           name="tttMetric"
                           value="receivedAt"
                           onChange={setTTTMetric} />
                    <label>Received At</label>
                </div>
            </div>
        )
}

export default MatrixTimeToTriggerMenu;